function formatDate(date) {
    var day = date.getDate() - 3;
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    if(day < 1){
      day = 1;
    }
    return `${month}. ${day}, ${year}`;
}

// Setting the text of elements with the data-order-by attribute
document.querySelectorAll('[data-order-by]').forEach(element => {
    element.textContent = formatDate(new Date());
});


var bottomATC = document.getElementById('bottomStickyATC');
/* Add event listener for scroll event for the bottom sticky ATC
window.addEventListener('scroll', function() {    
    //This is for a/b test 8-26-2024 to test if adding turning on the bottomATC sooner improves conversion
    if(firstTouchLoad){
        if (window.scrollY >= 15) {
            // Add your class to the element
            bottomATC.classList.add('is-active');
        } else {
            // Remove the class if scroll position is less than 1000px
            bottomATC.classList.remove('is-active');
        }
    }else{
        // Check if the scroll position is 1000px or more
        if (window.scrollY >= 800) {
            // Add your class to the element
            bottomATC.classList.add('is-active');
        } else {
            // Remove the class if scroll position is less than 1000px
            bottomATC.classList.remove('is-active');
        }
    }
});*/

//scrolls to first CTA if top bar is clicked 
function save56scrollToCTA() {
    document.getElementById('tenReasons-upsell-wrapper').scrollIntoView({behavior: 'smooth'});
 }